"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@amatiasq/util");
var util_2 = require("./util");
var SquaredCircle = /** @class */ (function () {
    function SquaredCircle() {
    }
    SquaredCircle.fromCenter = function (x, y, radius) {
        var area = new SquaredCircle();
        area.x = x;
        area.y = y;
        area.radius = radius;
        return area;
    };
    SquaredCircle.prototype.is = function (target) {
        return (this.x === target.x &&
            this.y === target.y &&
            this.radius === target.radius);
    };
    SquaredCircle.prototype.containsPoint = function (target) {
        return util_2.containsPoint(this, target);
    };
    SquaredCircle.prototype.contains = function (target) {
        return util_2.contains(this, target);
    };
    SquaredCircle.prototype.collides = function (target) {
        return util_2.collides(this, target);
    };
    SquaredCircle.prototype.toString = function () {
        return "[" + this.top + "," + this.left + "][" + this.bottom + "," + this.right + "]";
    };
    return SquaredCircle;
}());
exports.default = SquaredCircle;
Object.defineProperties(SquaredCircle.prototype, {
    x: util_1.accessor('_x', onHorizontalSizeChange),
    y: util_1.accessor('_y', onVerticalSizeChange),
    radius: util_1.accessor('_radius', onRadiusChange),
    diameter: util_1.accessor('_diameter', onDiameterChange),
    width: util_1.accessor('diameter'),
    height: util_1.accessor('diameter'),
    halfWidth: util_1.accessor('radius'),
    halfHeight: util_1.accessor('radius'),
    top: util_1.accessor('_top', onVerticalPositionChange),
    left: util_1.accessor('_left', onHorizontalPositionChange),
    right: util_1.accessor('_right', onHorizontalPositionChange),
    bottom: util_1.accessor('_bottom', onVerticalPositionChange),
});
function onHorizontalSizeChange(area) {
    area._left = area._x - area._radius;
    area._right = area._x + area._radius;
}
function onVerticalSizeChange(area) {
    area._top = area._y - area._radius;
    area._bottom = area._y + area._radius;
}
function onRadiusChange(area) {
    area._diameter = area._radius * 2;
    onHorizontalSizeChange(area);
    onVerticalSizeChange(area);
}
function onDiameterChange(area) {
    area._radius = area._diameter / 2;
    onHorizontalSizeChange(area);
    onVerticalSizeChange(area);
}
function onVerticalPositionChange(area, prev, value) {
    area._y += value - prev;
    onVerticalSizeChange(area);
}
function onHorizontalPositionChange(area, prev, value) {
    area._x += value - prev;
    onHorizontalSizeChange(area);
}
